let initialState = {
  comments: {},
  item: null,
  showCommentsDialog: false,
  isLoading: false,
};

const priceActionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_COMMENTS': {
      return Object.assign({}, state, {
        comments: Object.assign({}, state.comments, {
          [action.payload.priceId]: action.payload.comments,
        }),
      });
    }
    case 'ADD_COMMENT': {
      return Object.assign({}, state, {
        isLoading: false,
        comments: Object.assign({}, state.comments, {
          [action.payload.priceId]: [
            {
              CreatedOn: new Date(),
              Comment: action.payload.comment,
              UserName: action.payload.user,
            },
          ].concat(state.comments[action.payload.priceId] || []),
        }),
      });
    }
    case 'TOGGLE_COMMENTS_DIALOG_VISIBILITY': {
      return Object.assign({}, state, {
        showCommentsDialog: !state.showCommentsDialog,
        item: action.payload,
      });
    }
    case 'SET_COMMENTS_LOADING': {
      return Object.assign({}, state, { isLoading: action.payload });
    }
    case 'NOTIFICATION_TYPE': {
      let { Type, data } = action.payload;
      let comments = Object.assign({}, state.comments);
      switch (Type) {
        case 'comment': {
          if (comments[data.PriceId]) {
            comments[data.PriceId] = [data].concat(comments[data.PriceId]);
          }
          break;
        }
        default:
          break;
      }
      return Object.assign({}, state, {
        comments: Object.assign({}, comments),
      });
    }
    case 'LOGOUT': {
      return initialState;
    }
    default:
      return state;
  }
};
export default priceActionReducer;
